// @flow

import React from 'react';

import {gt} from 'app/utils/i18n';
import {StoredProcessesFetcher} from 'app/process/datafetchers';
import {CompactProcessItem} from 'app/process/components/CompactProcessItem';
import {GenericPaginatedList} from 'app/components/general/lists/GenericPaginatedList';

export const ProcessList = () => (
  <GenericPaginatedList
    ItemComponent={CompactProcessItem}
    FetcherComponent={StoredProcessesFetcher}
    noItemsMessage={() =>
      gt("This member doesn't have access to any processes")
    }
    paramsBuilder={({params}) => ({
      visible_to_user: params.userid,
    })}
    customProps={() => ({
      actionsGetter: () => [],
    })}
  />
);
